function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Components-/-Clocks",
  transform: "translate(-13.000000, -49.000000)"
}, React.createElement("g", {
  id: "dotted-line",
  transform: "translate(7.000000, 26.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(6.000000, 23.000000)"
}, React.createElement("circle", {
  id: "Oval-Copy-11",
  fill: "#06273A",
  opacity: 0.5,
  cx: 1.5,
  cy: 5,
  r: 1.5
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0.0111839658,
  x: 0,
  y: 0,
  width: 3,
  height: 10
})))));

var SvgDottedLine = function SvgDottedLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "3px",
    height: "10px",
    viewBox: "0 0 3 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDottedLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dotted-line.9dbdd0bb.svg";
export { ForwardRef as ReactComponent };